// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1728":"7ed31f643f2bbadd","4546":"482e978a397c6b9f","7296":"7639a1598cb1e058","7675":"fb9e6c84a772caea","8560":"7490e7295df62f08"}[chunkId] + ".css";
};